import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  deleteCandidate,
  saveEditCandidateProfile,
} from '/redux/action/candidate.action';
import {
  emailById,
  nameById,
  phoneNumberById,
  urlDetailsById,
} from '/redux/selector/candidate.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {allReportData} from '/redux/selector/report.selector';
import {withProps} from '/util/selector.util';

import {CandidateEditProfile} from './CandidateEditProfile';

export default connect(
  createStructuredSelector({
    newName: nameById,
    newEmail: emailById,
    newPhone: phoneNumberById,
    urlDetails: urlDetailsById,
    allReportData,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),

  dispatch => ({
    deleteCandidate: ({candidateId, allReportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(deleteCandidate({candidateId, allReportData})),
    saveEditCandidateProfile: ({candidateId, body, allReportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(saveEditCandidateProfile({candidateId, body, allReportData})),
  }),

  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    deleteCandidate: () => {
      const {candidateId} = ownProps;
      const {allReportData} = stateProps;
      return dispatchProps.deleteCandidate({
        candidateId,
        allReportData,
      });
    },
    saveEditCandidateProfile: (body: any) => {
      const {candidateId} = ownProps;
      const {allReportData} = stateProps;
      return dispatchProps.saveEditCandidateProfile({
        candidateId,
        body,
        allReportData,
      });
    },
  }),
)(CandidateEditProfile);
